import React from 'react';

type Props = {
  width?: string;
  height?: string;
  color?: string;
};

const CirclePlusIcon = (props: Props) => {
  const { width = '17', height = '16', color = '#17C964' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M8.5 1.5C7.21442 1.5 5.95772 1.88122 4.8888 2.59545C3.81988 3.30968 2.98676 4.32484 2.49479 5.51256C2.00282 6.70028 1.87409 8.00721 2.1249 9.26809C2.3757 10.529 2.99477 11.6872 3.90381 12.5962C4.81285 13.5052 5.97104 14.1243 7.23192 14.3751C8.49279 14.6259 9.79973 14.4972 10.9874 14.0052C12.1752 13.5132 13.1903 12.6801 13.9046 11.6112C14.6188 10.5423 15 9.28558 15 8C14.9982 6.27665 14.3128 4.62441 13.0942 3.40582C11.8756 2.18722 10.2234 1.50182 8.5 1.5ZM8.5 13.5C7.41221 13.5 6.34884 13.1774 5.44437 12.5731C4.5399 11.9687 3.83495 11.1098 3.41867 10.1048C3.00238 9.09977 2.89347 7.9939 3.10568 6.927C3.3179 5.86011 3.84173 4.8801 4.61092 4.11091C5.3801 3.34172 6.36011 2.8179 7.42701 2.60568C8.4939 2.39346 9.59977 2.50238 10.6048 2.91866C11.6098 3.33494 12.4687 4.03989 13.0731 4.94436C13.6774 5.84883 14 6.9122 14 8C13.9983 9.45818 13.4184 10.8562 12.3873 11.8873C11.3562 12.9184 9.95819 13.4983 8.5 13.5ZM11.5 8C11.5 8.13261 11.4473 8.25979 11.3536 8.35355C11.2598 8.44732 11.1326 8.5 11 8.5H9V10.5C9 10.6326 8.94732 10.7598 8.85356 10.8536C8.75979 10.9473 8.63261 11 8.5 11C8.36739 11 8.24022 10.9473 8.14645 10.8536C8.05268 10.7598 8 10.6326 8 10.5V8.5H6C5.86739 8.5 5.74022 8.44732 5.64645 8.35355C5.55268 8.25979 5.5 8.13261 5.5 8C5.5 7.86739 5.55268 7.74021 5.64645 7.64645C5.74022 7.55268 5.86739 7.5 6 7.5H8V5.5C8 5.36739 8.05268 5.24021 8.14645 5.14645C8.24022 5.05268 8.36739 5 8.5 5C8.63261 5 8.75979 5.05268 8.85356 5.14645C8.94732 5.24021 9 5.36739 9 5.5V7.5H11C11.1326 7.5 11.2598 7.55268 11.3536 7.64645C11.4473 7.74021 11.5 7.86739 11.5 8Z"
        fill={color}
      />
    </svg>
  );
};

export default CirclePlusIcon;
